/**
 * KINGRECHARGES STORE API ENDPOINTS
 * Basé sur l'intégration kingrecharges existante
 */

const API_BASE_URL = 'https://apis.1xpay.co';

export const ENDPOINTS = {
  // Produits - Abonnements
  PRODUCTS: {
    SUBSCRIPTIONS: '/stock-manager/stocks/kingrechargePlatformSubscription',
    GIFTCARDS: '/stock-manager/stocks/kingrechargeGiftcard',
    PRODUCT_DETAIL: (id) => `/stock-manager/stock/${id}`,
  },

  // Paiement
  PAYMENT: {
    LAUNCH: '/kingrecharge/launch/transaction/store',
    STATUS: (id) => `/kingrecharge/fetch/transaction/${id}`,
  },

  // Téléphone / Opérateur
  CARRIER: {
    RESOLVE: (phone) => `/carrier-mapper/v2/resolve/${phone}`,
  },

  // Simulations (pour développement)
  SIMULATOR: {
    CART: {
      GET: '/simulate/fetch/cart/',
      ADD: '/simulate/add/to/cart/',
      REMOVE: '/simulate/remove/from/cart/',
      EMPTY: '/simulate/empty/cart/',
      SET_QUANTITY: '/simulate/set/product/quantity/',
      INCREASE_QUANTITY: '/simulate/increase/product/quantity/',
      DECREASE_QUANTITY: '/simulate/decrease/product/quantity/',
      SET_DELIVERY: '/simulate/set/deliveryLoctioninto/cart/',
    },
  },
};

export default ENDPOINTS;
